import {Box} from '@mui/material';
import Grid from '@mui/material/Grid';
import muiStyled from '@mui/material/styles/styled';

import {EMMAI_FORMS} from '../../../../../../const';
import useEmmai from '../../../../../../hooks/providers/useEmmai';
import AddPractitionerButton from '../../AddPractitionerButton/AddPractitionerButton';
import PractitionerSelector from '../../PractitionerSelector/PracticionerSelector/PracticionerSelector';
import BackToPractitionerActivityButton from '../components/BackToPractitionerActivityButton/BackToPractitionerActivityButton';
import DeletePractitionerButton from '../components/DeletePractitionerButton/DeletePractitionerButton';
import EditPractitionerButton from '../components/EditPractitionerButton/EditPractitionerButton';
import SavePractitionerButton from '../components/SavePractitionerButton/SavePractitionerButton';

const PractitionerToolbarContainer = muiStyled(Box)(({theme}) => ({
  backgroundColor: '#77BCBC',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
  marginTop: theme.spacing(-1),
  marginBottom: theme.spacing(1.5),
  borderRadius: '30px'
}));

const PractitionerToolbar = () => {
  const {currentForm} = useEmmai();

  const shouldShowBack = currentForm !== EMMAI_FORMS.OFFICE_AND_PRACTITIONER_ACTIVITY;

  return (
    <PractitionerToolbarContainer>
      <PractitionerSelector />

      <Grid container width="auto" flexWrap="nowrap">
        {shouldShowBack ? <BackToPractitionerActivityButton /> : <AddPractitionerButton variant="toolbar" />}

        <EditPractitionerButton />
        <SavePractitionerButton />
        <DeletePractitionerButton />
      </Grid>
    </PractitionerToolbarContainer>
  );
};

export default PractitionerToolbar;
